export default {
  categoryCollection: [],
};
